import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSiteConfig } from '../context/SiteConfigContext';

const AuctionsPublicGate: React.FC = () => {
  const { auctionsPublicEnabled, loading } = useSiteConfig();

  if (loading) return null;
  if (!auctionsPublicEnabled) return <Navigate to="/" replace />;
  return <Outlet />;
};

export default AuctionsPublicGate;
